export default [
  'top-10-bathroom-trends',
  'outdoor-living-hardscaping',
  'adu-mother-in-law-suite',
  'living-room-renovation-ideas',
  'bedroom-renovation-guide',
  'top-10-kitchen-trends',
  'voyagela-feature-modern-build-home-remodeling',
  'adu-garage-mother-in-law-suite',
  'kitchen-remodeling-cost-breakdown',
  'modern-kitchen-remodeling-ideas',
  'bathroom-remodeling-cost-guide',
  'adu-garage-conversion-cost-guide',
  'complete-home-remodeling-services',
  'modern-bathroom-renovation-ideas',
  'home-hvac-system-upgrade-cost',
  'bathroom-vanity-installation-cost-guide',
  'home-remodeling-contractor-selection-guide',
  'kitchen-countertop-installation-cost-guide'
];